import { render, staticRenderFns } from "./r-trader-offer-table.vue?vue&type=template&id=947d79a2"
import script from "./r-trader-offer-table.vue?vue&type=script&lang=js"
export * from "./r-trader-offer-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('947d79a2')) {
      api.createRecord('947d79a2', component.options)
    } else {
      api.reload('947d79a2', component.options)
    }
    module.hot.accept("./r-trader-offer-table.vue?vue&type=template&id=947d79a2", function () {
      api.rerender('947d79a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-offer-table.vue"
export default component.exports